import { addDays, torontoDate, torontoMidnight } from "../time/toronto";

export type PeriodPreset = "this_month" | "last_month" | "quarter" | "custom";
const iso = (y: number, m: number, d: number) =>
  new Date(Date.UTC(y, m - 1, d)).toISOString().slice(0, 10);

export const presetRange = (
  preset: Exclude<PeriodPreset, "custom">,
  now: Date,
): { from: string; to: string } => {
  const today = torontoDate(now);
  const [y, m] = today.split("-").map(Number);
  if (preset === "last_month")
    return { from: iso(y, m - 1, 1), to: iso(y, m, 0) };
  if (preset === "quarter")
    return { from: iso(y, Math.floor((m - 1) / 3) * 3 + 1, 1), to: today };
  return { from: iso(y, m, 1), to: today };
};

export const daysInclusive = (from: string, to: string): number =>
  Math.round(
    (Date.parse(`${to}T00:00:00Z`) - Date.parse(`${from}T00:00:00Z`)) /
      86_400_000,
  ) + 1;

export const previousPeriod = (from: string, to: string) => {
  const len = daysInclusive(from, to);
  return { from: addDays(from, -len), to: addDays(from, -1) };
};

/** [start, end) epoch ms of the local-date period; SQL: p_from / (p_to + 1) at time zone 'America/Toronto'. */
export const periodBounds = (from: string, to: string) => ({
  start: torontoMidnight(from).getTime(),
  end: torontoMidnight(addDays(to, 1)).getTime(),
});
